import { render, staticRenderFns } from "./OrganizationEdit.vue?vue&type=template&id=51013d0f&"
import script from "./OrganizationEdit.vue?vue&type=script&lang=ts&"
export * from "./OrganizationEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports